import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/policy-pages.scss";
import { Link } from "react-router-dom";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="prestige--v4 features--heading-small features--heading-uppercase template-index">
      <div className="PageContainer">
        <Header />
        <main id="main" role="main">
          <div className="shopify-policy__container">
            <div className="shopify-policy__title PageHeader Heading u-h1">
              <h1>Privacy policy</h1>
            </div>
            <div className="shopify-policy__body Rte">
              <div className="rte">
                <p>
                  This Privacy Policy describes how bakimball.world (the “Site”
                  or “we”) collects, uses, and discloses your Personal
                  Information when you visit or make a purchase from the Site.
                </p>
                <h1>Contact</h1>
                <p>
                  After reviewing this policy, if you have additional questions,
                  want more information about our privacy practices, or would
                  like to make a complaint, please contact us by e-mail at
                  vert@bakimball.world or by mail using the details provided
                  below:
                </p>
                <p>
                  Bakimball, 16 Madison Square West, 5th Floor, New York NY
                  10010, United States
                </p>
                <h1>Collecting Personal Information</h1>
                <p>
                  When you visit the Site, we collect certain information about
                  your device, your interaction with the Site, and information
                  necessary to process your purchases. We may also collect
                  additional information if you contact us for customer support.
                  In this Privacy Policy, we refer to any information about an
                  identifiable individual (including the information below) as
                  “Personal Information”. See the list below for more
                  information about what Personal Information we collect and
                  why.
                </p>
                <ul>
                  <li>
                    <u>Device information</u>
                  </li>
                  <ul>
                    <li>
                      <strong>Purpose of collection:</strong> to load the Site
                      accurately for you, and to perform analytics on Site usage
                      to optimize our Site.
                    </li>
                    <li>
                      <strong>Source of collection:</strong> Collected
                      automatically when you access our Site using cookies, log
                      files, web beacons, tags, or pixels.
                    </li>
                    <li>
                      <strong>Disclosure for a business purpose:</strong> shared
                      with our processor Shopify.
                    </li>
                    <li>
                      <strong>Personal Information collected:</strong> version
                      of web browser, IP address, time zone, cookie information,
                      what sites or products you view, search terms, and how you
                      interact with the Site.
                    </li>
                  </ul>
                  <li>
                    <u>Order information</u>
                  </li>
                  <ul>
                    <li>
                      <strong>Purpose of collection:</strong> to provide
                      products or services to you to fulfill our contract, to
                      process your payment information, arrange for shipping,
                      and provide you with invoices and/or order confirmations,
                      communicate with you, screen our orders for potential risk
                      or fraud, and when in line with the preferences you have
                      shared with us, provide you with information or
                      advertising relating to our products or services.
                    </li>
                    <li>
                      <strong>Source of collection:</strong> collected from you.
                    </li>
                    <li>
                      <strong>Disclosure for a business purpose:</strong> shared
                      with our processor Shopify.
                    </li>
                    <li>
                      <strong>Personal Information collected:</strong> name,
                      billing address, shipping address, payment information
                      (including credit card numbers, email address, and phone
                      number.
                    </li>
                  </ul>
                  <li>
                    <u>Customer support information</u>
                  </li>
                  <ul>
                    <li>
                      <strong>Purpose of collection: </strong>To provide
                      customer support, including assistance via email or
                      contact form.
                    </li>
                    <li>
                      <strong>Source of collection: </strong>Collected directly
                      from you when you contact customer care. &nbsp;
                    </li>
                    <li>
                      <strong>Disclosure for a business purpose: </strong>Shared
                      with service providers as needed to support customer
                      inquiries and maintain service levels (e.g., Shopify for
                      data processing).
                    </li>
                    <li>
                      <strong>Personal Information collected:</strong> Could
                      include your name, email address, order number, message
                      content, and any additional details you provide during the
                      support interaction.
                      <strong />
                    </li>
                  </ul>
                </ul>
                <p>Sharing Personal Information</p>
                <p>
                  We share your Personal Information with service providers to
                  help us provide our services and fulfill our contracts with
                  you, as described above. For example:
                </p>
                <ul>
                  <li>
                    We use Shopify to power our online store. You can read more
                    about how Shopify uses your Personal Information here:{" "}
                    <Link onClick={toTop} to="/privacy">
                      https://www.shopify.com/legal/privacy
                    </Link>
                    .
                  </li>
                  <li>
                    We may share your Personal Information to comply with
                    applicable laws and regulations, to respond to a subpoena,
                    search warrant or other lawful request for information we
                    receive, or to otherwise protect our rights.
                  </li>
                </ul>
                <p style={{ fontWeight: 400 }}>SMS Abandoned Cart disclosure</p>
                <p style={{ fontWeight: 400 }}>
                  The&nbsp;Bakimball website (www.bakimball.world) uses cookies
                  to help keep track of items you put into your shopping cart
                  including when you have abandoned your cart and this
                  information is used to determine when to send cart reminder
                  messages via SMS.
                </p>
                <p style={{ fontWeight: 400 }}>Third Party data sharing</p>
                <p style={{ fontWeight: 400 }}>
                  The above excludes text messaging originator opt-in data and
                  consent; this information will not be shared with any third
                  parties.&nbsp;
                </p>
                <h1>Behavioural Advertising</h1>
                <p>
                  <span>
                    As described above, we use your Personal Information to
                    provide you with targeted advertisements or marketing
                    communications we believe may be of interest to you. For
                    example:
                  </span>
                  <b />
                </p>
                <ul>
                  <li>
                    <p>
                      <span>
                        When you visit or log in to our website, cookies and
                        similar technologies may be used by our online data
                        partners or vendors to associate these activities with
                        other personal information they or others have about
                        you, including by association with your email or home
                        address. We (or service providers on our behalf) may
                        then send communications and marketing to these email or
                        home addresses. You may opt out of receiving this
                        advertising by visiting&nbsp;
                      </span>
                      <Link onClick={toTop} to="/">
                        <span>here</span>
                      </Link>
                      <span>.</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        We use Google Analytics to help us understand how our
                        customers use the Site. You can read more about how
                        Google uses your Personal Information{" "}
                      </span>
                      <Link onClick={toTop} to="/">
                        <span>here</span>
                      </Link>
                      <span>. You can also opt-out of Google Analytics </span>
                      <Link onClick={toTop} to="/">
                        <span>here</span>
                      </Link>
                      <span>.</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        We share information about your use of the Site, your
                        purchases, and your interaction with our ads on other
                        websites with our advertising partners. We collect and
                        share some of this information directly with our
                        advertising partners, and in some cases through the use
                        of cookies or other similar technologies (which you may
                        consent to, depending on your location).
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  <span>
                    For more information about how targeted advertising works,
                    you can visit the Network Advertising Initiative’s (“NAI”)
                    educational page{" "}
                  </span>
                  <Link onClick={toTop} to="/">
                    <span>here</span>
                  </Link>
                  <span>.</span>
                </p>
                <p>
                  <span>You can opt out of targeted advertising by:</span>
                </p>
                <ul>
                  <li>
                    <p>
                      <Link
                        onClick={toTop}
                        to="https://www.facebook.com/settings/?tab=ads"
                      >
                        <span>FACEBOOK</span>
                      </Link>
                      <span>&nbsp;&nbsp;</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <Link
                        onClick={toTop}
                        to="https://www.google.com/settings/ads/anonymous"
                      >
                        <span>GOOGLE</span>
                      </Link>
                      <span>&nbsp;</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <Link
                        onClick={toTop}
                        to="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
                      >
                        <span>BING</span>
                      </Link>
                      <span>&nbsp;</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <Link
                        onClick={toTop}
                        to="https://app.retention.com/optout"
                      >
                        <span>EMAIL</span>
                      </Link>
                      <span> </span>
                      <span />
                    </p>
                  </li>
                </ul>
                <p>
                  <span />
                  <b id="docs-internal-guid-f0531d13-7fff-4ace-9b69-63727edf47d6" />
                  Additionally, you can opt out of some of these services by
                  visiting the Digital Advertising Alliance’s opt-out
                  portal&nbsp;
                  <Link onClick={toTop} to="/">
                    here
                  </Link>
                  .
                  <b id="docs-internal-guid-f0531d13-7fff-4ace-9b69-63727edf47d6">
                    <span> </span>
                  </b>
                  <br />
                </p>
                <h1>Using Personal Information</h1>
                <p>
                  We use your personal Information to provide our services to
                  you, which includes: offering products for sale, processing
                  payments, shipping and fulfillment of your order, and keeping
                  you up to date on new products, services, and offers.
                </p>
                <h2>Lawful basis</h2>
                <p>
                  Pursuant to the General Data Protection Regulation (“GDPR”),
                  if you are a resident of the European Economic Area (“EEA”),
                  we process your personal information under the following
                  lawful bases:
                </p>
                <ul>
                  <li>Your consent;</li>
                  <li>
                    The performance of the contract between you and the Site;
                  </li>
                  <li>Compliance with our legal obligations;</li>
                  <li>To protect your vital interests;</li>
                  <li>To perform a task carried out in the public interest;</li>
                  <li>
                    For our legitimate interests, which do not override your
                    fundamental rights and freedoms.
                  </li>
                </ul>
                <h2>Retention</h2>
                <p>
                  When you place an order through the Site, we will retain your
                  Personal Information for our records unless and until you ask
                  us to erase this information. For more information on your
                  right of erasure, please see the ‘Your rights’ section below.
                </p>
                <h2>Automatic decision-making</h2>
                <p>
                  If you are a resident of the EEA, you have the right to object
                  to processing based solely on automated decision-making (which
                  includes profiling), when that decision-making has a legal
                  effect on you or otherwise significantly affects you.
                </p>
                <p>
                  Our processor Shopify uses limited automated decision-making
                  to prevent fraud that does not have a legal or otherwise
                  significant effect on you.
                </p>
                <p>
                  Services that include elements of automated decision-making
                  include:
                </p>
                <ul>
                  <li>
                    Temporary blacklist of IP addresses associated with repeated
                    failed transactions. This blacklist persists for a small
                    number of hours.
                  </li>
                  <li>
                    Temporary blacklist of credit cards associated with
                    blacklisted IP addresses. This blacklist persists for a
                    small number of days.
                  </li>
                </ul>
                <h1>Your rights</h1>
                <p>
                  <i />
                  GDPR
                </p>
                <p>
                  If you are a resident of the EEA, you have the right to access
                  the Personal Information we hold about you, to port it to a
                  new service, and to ask that your Personal Information be
                  corrected, updated, or erased. If you would like to exercise
                  these rights, please contact us at vert@bakimball.world&nbsp;
                </p>
                <p>
                  Your Personal Information will be initially processed in
                  Ireland and then will be transferred outside of Europe for
                  storage and further processing, including to Canada and the
                  United States. For more information on how data transfers
                  comply with the GDPR, see Shopify’s GDPR Whitepaper:{" "}
                  <Link onClick={toTop} to="/">
                    https://help.shopify.com/en/manual/your-account/privacy/GDPR
                  </Link>
                  .
                </p>
                <h2>CCPA</h2>
                <p>
                  If you are a resident of California, you have the right to
                  access the Personal Information we hold about you (also known
                  as the ‘Right to Know’), to port it to a new service, and to
                  ask that your Personal Information be corrected, updated, or
                  erased. If you would like to exercise these rights, please
                  contact us at vert@bakimball.world.
                </p>
                <p>
                  If you would like to designate an authorized agent to submit
                  these requests on your behalf, please contact us at the
                  address above.
                </p>
                <h1>Cookies</h1>
                <p>
                  A cookie is a small amount of information that’s downloaded to
                  your computer or device when you visit our Site. We use a
                  number of different cookies, including functional,
                  performance, advertising, and social media or content cookies.
                  Cookies make your browsing experience better by allowing the
                  website to remember your actions and preferences (such as
                  login and region selection). This means you don’t have to
                  re-enter this information each time you return to the site or
                  browse from one page to another. Cookies also provide
                  information on how people use the website, for instance
                  whether it’s their first time visiting or if they are a
                  frequent visitor.
                </p>
                <p>
                  We use the following cookies to optimize your experience on
                  our Site and to provide our services.
                </p>
                <p>
                  <i />
                  Cookies Necessary for the Functioning of the Store
                </p>
                <table>
                  <thead>
                    <tr>
                      <th>
                        <strong>Name</strong>
                      </th>
                      <th>
                        <strong>Function</strong>
                      </th>
                      <th>
                        <strong>Duration</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>_ab</td>
                      <td>Used in connection with access to admin.</td>
                      <td>2y</td>
                    </tr>
                    <tr>
                      <td>_secure_session_id</td>
                      <td>
                        Used in connection with navigation through a storefront.
                      </td>
                      <td>24h</td>
                    </tr>
                    <tr>
                      <td>_shopify_country</td>
                      <td>Used in connection with checkout.</td>
                      <td>session</td>
                    </tr>
                    <tr>
                      <td>_shopify_m</td>
                      <td>Used for managing customer privacy settings.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>_shopify_tm</td>
                      <td>Used for managing customer privacy settings.</td>
                      <td>30min</td>
                    </tr>
                    <tr>
                      <td>_shopify_tw</td>
                      <td>Used for managing customer privacy settings.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>_storefront_u</td>
                      <td>
                        Used to facilitate updating customer account
                        information.
                      </td>
                      <td>1min</td>
                    </tr>
                    <tr>
                      <td>_tracking_consent</td>
                      <td>Tracking preferences.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>c</td>
                      <td>Used in connection with checkout.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>cart</td>
                      <td>Used in connection with shopping cart.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>cart_currency</td>
                      <td>Used in connection with shopping cart.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>cart_sig</td>
                      <td>Used in connection with checkout.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>cart_ts</td>
                      <td>Used in connection with checkout.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>cart_ver</td>
                      <td>Used in connection with shopping cart.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>checkout</td>
                      <td>Used in connection with checkout.</td>
                      <td>4w</td>
                    </tr>
                    <tr>
                      <td>checkout_token</td>
                      <td>Used in connection with checkout.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>dynamic_checkout_shown_on_cart</td>
                      <td>Used in connection with checkout.</td>
                      <td>30min</td>
                    </tr>
                    <tr>
                      <td>hide_shopify_pay_for_checkout</td>
                      <td>Used in connection with checkout.</td>
                      <td>session</td>
                    </tr>
                    <tr>
                      <td>keep_alive</td>
                      <td>Used in connection with buyer localization.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>master_device_id</td>
                      <td>Used in connection with merchant login.</td>
                      <td>2y</td>
                    </tr>
                    <tr>
                      <td>previous_step</td>
                      <td>Used in connection with checkout.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>remember_me</td>
                      <td>Used in connection with checkout.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>secure_customer_sig</td>
                      <td>Used in connection with customer login.</td>
                      <td>20y</td>
                    </tr>
                    <tr>
                      <td>shopify_pay</td>
                      <td>Used in connection with checkout.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>shopify_pay_redirect</td>
                      <td>Used in connection with checkout.</td>
                      <td>30 minutes, 3w or 1y depending on value</td>
                    </tr>
                    <tr>
                      <td>storefront_digest</td>
                      <td>Used in connection with customer login.</td>
                      <td>2y</td>
                    </tr>
                    <tr>
                      <td>tracked_start_checkout</td>
                      <td>Used in connection with checkout.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>checkout_one_experiment</td>
                      <td>Used in connection with checkout.</td>
                      <td>session</td>
                    </tr>
                  </tbody>
                </table>
                <h2>Reporting and Analytics</h2>
                <table>
                  <thead>
                    <tr>
                      <th>
                        <strong>Name</strong>
                      </th>
                      <th>
                        <strong>Function</strong>
                      </th>
                      <th>
                        <strong>Duration</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>_landing_page</td>
                      <td>Track landing pages.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>_orig_referrer</td>
                      <td>Track landing pages.</td>
                      <td>2w</td>
                    </tr>
                    <tr>
                      <td>_s</td>
                      <td>Shopify analytics.</td>
                      <td>30min</td>
                    </tr>
                    <tr>
                      <td>_shopify_d</td>
                      <td>Shopify analytics.</td>
                      <td>session</td>
                    </tr>
                    <tr>
                      <td>_shopify_s</td>
                      <td>Shopify analytics.</td>
                      <td>30min</td>
                    </tr>
                    <tr>
                      <td>_shopify_sa_p</td>
                      <td>
                        Shopify analytics relating to marketing &amp; referrals.
                      </td>
                      <td>30min</td>
                    </tr>
                    <tr>
                      <td>_shopify_sa_t</td>
                      <td>
                        Shopify analytics relating to marketing &amp; referrals.
                      </td>
                      <td>30min</td>
                    </tr>
                    <tr>
                      <td>_shopify_y</td>
                      <td>Shopify analytics.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>_y</td>
                      <td>Shopify analytics.</td>
                      <td>1y</td>
                    </tr>
                    <tr>
                      <td>_shopify_evids</td>
                      <td>Shopify analytics.</td>
                      <td>session</td>
                    </tr>
                    <tr>
                      <td>_shopify_ga</td>
                      <td>Shopify and Google Analytics.</td>
                      <td>session</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <br />
                </p>
                <p>
                  The length of time that a cookie remains on your computer or
                  mobile device depends on whether it is a “persistent” or
                  “session” cookie. Session cookies last until you stop browsing
                  and persistent cookies last until they expire or are deleted.
                  Most of the cookies we use are persistent and will expire
                  between 30 minutes and two years from the date they are
                  downloaded to your device.
                </p>
                <p>
                  You can control and manage cookies in various ways. Please
                  keep in mind that removing or blocking cookies can negatively
                  impact your user experience and parts of our website may no
                  longer be fully accessible.
                </p>
                <p>
                  Most browsers automatically accept cookies, but you can choose
                  whether or not to accept cookies through your browser
                  controls, often found in your browser’s “Tools” or
                  “Preferences” menu. For more information on how to modify your
                  browser settings or how to block, manage or filter cookies can
                  be found in your browser’s help file or through such sites as:{" "}
                  <Link onClick={toTop} to="/">
                    www.allaboutcookies.org
                  </Link>
                  .
                </p>
                <p>
                  Additionally, please note that blocking cookies may not
                  completely prevent how we share information with third parties
                  such as our advertising partners. To exercise your rights or
                  opt-out of certain uses of your information by these parties,
                  please follow the instructions in the “Behavioural
                  Advertising” section above.
                </p>
                <h2>Do Not Track</h2>
                <p>
                  Please note that because there is no consistent industry
                  understanding of how to respond to “Do Not Track” signals, we
                  do not alter our data collection and usage practices when we
                  detect such a signal from your browser.
                </p>
                <h1>Changes</h1>
                <p>
                  We may update this Privacy Policy from time to time in order
                  to reflect, for example, changes to our practices or for other
                  operational, legal, or regulatory reasons.
                </p>
                <h1>Complaints</h1>
                <p>
                  As noted above, if you would like to make a complaint, please
                  contact us by e-mail or by mail using the details provided
                  under “Contact” above.
                </p>
                <p>
                  If you are not satisfied with our response to your complaint,
                  you have the right to lodge your complaint with the relevant
                  data protection authority. You can contact your local data
                  protection authority, or our supervisory authority here:{" "}
                  <i>
                    [Add contact information or website for the data protection
                    authority in your jurisdiction. For example:{" "}
                    <Link onClick={toTop} to="/">
                      https://ico.org.uk/make-a-complaint/
                    </Link>
                    ]
                  </i>
                </p>
                <p>
                  Last updated: <i>6-16-2022</i>
                </p>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default Privacy;
